@if (open) {
  <div class="fixed inset-0 z-[100000]">
    <div class="backdrop absolute inset-0 bg-gray-900/40 backdrop-blur-[2px]" (click)="close()" aria-hidden="true"></div>

    <aside class="sheet absolute inset-x-0 bottom-0 flex max-h-[88vh] flex-col rounded-t-2xl bg-white shadow-theme-xl sm:inset-y-0 sm:left-auto sm:right-0 sm:max-h-none sm:w-[27rem] sm:rounded-none sm:rounded-l-2xl dark:bg-gray-dark"
      role="dialog" aria-modal="true" aria-labelledby="rpt-reading-title">

      <header class="flex items-start justify-between gap-4 border-b border-gray-100 px-6 pb-4 pt-5 dark:border-gray-800">
        <div>
          <h2 id="rpt-reading-title" class="text-base font-semibold text-gray-900 dark:text-white">Resumen del período</h2>
          <p class="mt-0.5 text-sm text-gray-500 dark:text-gray-400">Del {{ rangeLabel }}</p>
        </div>
        <button #closeBtn type="button" (click)="close()" aria-label="Cerrar resumen"
          class="-mr-2 inline-flex h-9 w-9 items-center justify-center rounded-lg text-gray-500 hover:bg-gray-100 hover:text-gray-800 focus-visible:outline-2 focus-visible:outline-brand-500 dark:text-gray-400 dark:hover:bg-white/5 dark:hover:text-white">
          <svg class="h-5 w-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true"><path stroke-linecap="round" d="M6 18 18 6M6 6l12 12" /></svg>
        </button>
      </header>

      <div class="flex-1 overflow-y-auto px-6 py-5">
        <p class="font-display text-[1.375rem] font-semibold leading-snug tracking-tight text-gray-900 tabular-nums dark:text-white">{{ headline }}</p>

        @if (items.length) {
          <ul class="mt-6 space-y-2.5">
            @for (item of items; track item.kind) {
              <li class="flex gap-3.5 rounded-xl border border-gray-100 p-3.5 dark:border-gray-800">
                <span class="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-lg"
                  [class]="item.tone === 'up'
                    ? 'bg-success-50 text-success-600 dark:bg-success-500/15 dark:text-success-400'
                    : item.tone === 'down'
                      ? 'bg-error-50 text-error-600 dark:bg-error-500/15 dark:text-error-400'
                      : 'bg-gray-100 text-gray-600 dark:bg-white/5 dark:text-gray-300'">
                  <svg class="h-[1.125rem] w-[1.125rem]" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" viewBox="0 0 24 24" aria-hidden="true">
                    @switch (item.kind) {
                      @case ('revenue') {
                        @if (item.tone === 'down') { <path d="m3 7 6 6 4-4 8 8M21 11v6h-6" /> } @else { <path d="m3 17 6-6 4 4 8-8M21 13V7h-6" /> }
                      }
                      @case ('service') { <path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z" /><circle cx="7.5" cy="7.5" r="1.2" /> }
                      @case ('attendance') { <circle cx="12" cy="12" r="9" /><path d="m8 12 3 3 5-6" /> }
                      @case ('clients') { <circle cx="9" cy="8" r="3.5" /><path d="M3 20a6 6 0 0 1 12 0M19 8v6M16 11h6" /> }
                      @case ('pending') { <circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /> }
                    }
                  </svg>
                </span>
                <div class="min-w-0">
                  <p class="font-semibold text-gray-900 tabular-nums dark:text-white">{{ item.title }}</p>
                  <p class="mt-0.5 text-sm leading-relaxed text-gray-600 tabular-nums dark:text-gray-300">{{ item.detail }}</p>
                </div>
              </li>
            }
          </ul>
        } @else {
          <p class="mt-4 text-sm text-gray-500 dark:text-gray-400">Cuando haya citas y pagos en estas fechas, aquí verás lo más importante del período.</p>
        }
      </div>

      <footer class="flex flex-col gap-2 border-t border-gray-100 px-6 py-4 sm:flex-row dark:border-gray-800">
        <button type="button" (click)="copy()"
          class="inline-flex h-10 flex-1 items-center justify-center gap-2 rounded-xl bg-gray-900 px-4 text-sm font-medium text-white hover:bg-gray-800 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 dark:bg-white dark:text-gray-900 dark:hover:bg-gray-100">
          <svg class="h-4 w-4" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24" aria-hidden="true">
            @if (copied()) {
              <path stroke-linecap="round" stroke-linejoin="round" d="m5 13 4 4L19 7" />
            } @else {
              <rect x="9" y="9" width="11" height="11" rx="2" /><path stroke-linecap="round" d="M5 15V6a2 2 0 0 1 2-2h8" />
            }
          </svg>
          <span aria-live="polite">{{ copied() ? 'Resumen copiado' : 'Copiar resumen' }}</span>
        </button>
        @if (canDownload) {
          <button type="button" (click)="downloadPdf.emit()"
            class="inline-flex h-10 flex-1 items-center justify-center gap-2 rounded-xl border border-gray-200 px-4 text-sm font-medium text-gray-700 hover:bg-gray-50 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-500 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-white/5">
            Descargar PDF
          </button>
        }
      </footer>
    </aside>
  </div>
}
